import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../mock';
import { Logo } from './Logo';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <Logo className="h-28 w-auto brightness-0 invert" />
            </div>
            <p className="text-gray-400 mb-4">
              Experts en travaux acrobatiques et accès difficiles. 
              Plus de 13 ans d'expérience à votre service.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-600">Liens rapides</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('#accueil')}
                  className="text-gray-400 hover:text-orange-600 transition-colors"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('#apropos')}
                  className="text-gray-400 hover:text-orange-600 transition-colors"
                >
                  À propos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('#services')}
                  className="text-gray-400 hover:text-orange-600 transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('#contact')}
                  className="text-gray-400 hover:text-orange-600 transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-600">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-orange-600" />
                <a
                  href={`tel:${companyInfo.contact.phone.replace(/\s/g, '')}`}
                  className="text-gray-400 hover:text-orange-600 transition-colors"
                >
                  {companyInfo.contact.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-orange-600 mt-1" />
                <a
                  href={`mailto:${companyInfo.contact.email}`}
                  className="text-gray-400 hover:text-orange-600 transition-colors break-all"
                >
                  {companyInfo.contact.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-orange-600 mt-1" />
                <span className="text-gray-400">
                  {companyInfo.contact.address}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} AcrobaTisseur. Tous droits réservés.
            </p>
            <p className="text-gray-400 text-sm">
              Travaux acrobatiques • Île-de-France
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
